import classNames from 'classnames';
import {Link} from 'gatsby';
import React from 'react';

interface Props {
  children: React.ReactNode;
  to: string;
  color?: 'blue' | 'orange';
  className?: string;
}

const LinkButton = ({children, className, to, color = 'orange'}: Props) => {
  return (
    <Link
      to={to}
      className={classNames(
        'inline-flex rounded-full py-2.5 text-white font-medium justify-center',
        className,
        color === 'blue'
          ? 'bg-dark-blue hover:text-[#f69220]'
          : 'bg-primary hover:text-[#003c57]',
      )}>
      {children}
    </Link>
  );
};

export default LinkButton;
